import { AppLayout } from '@/components/layout/AppLayout';
import { AvatarSettings } from '@/components/settings/AvatarSettings';
import { CurrencySettings } from '@/components/settings/CurrencySettings';
import { ChartThemeSettings } from '@/components/settings/ChartThemeSettings';
import { ThemeSettings } from '@/components/settings/ThemeSettings';
import { NotificationSettings } from '@/components/settings/NotificationSettings';
import { BiometricSettings } from '@/components/settings/BiometricSettings';
import { PrivacySettings } from '@/components/settings/PrivacySettings';
import { SubscriptionSettings } from '@/components/settings/SubscriptionSettings';

export default function Settings() {
  return (
    <AppLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Configuración</h1>
          <p className="text-muted-foreground">Personaliza tu experiencia en FOCO Dashboard</p>
        </div>
        
        {/* Avatar section - full width */}
        <div className="max-w-3xl">
          <AvatarSettings />
        </div>
        
        {/* Biometric settings - full width for mobile */}
        {/* Oculto temporalmente: pendiente de habilitar cuando la autenticación biométrica esté funcional */}
        <div className="max-w-3xl hidden">
          <BiometricSettings />
        </div>

        <div className="max-w-3xl">
          <SubscriptionSettings />
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-2 max-w-3xl">
          <ThemeSettings />
          <NotificationSettings />
          <CurrencySettings />
          <ChartThemeSettings />
          <PrivacySettings />
        </div>

      </div>
    </AppLayout>
  );
}
